import React, { useMemo } from 'react';
import Lottie from 'react-lottie';
import { useTheme } from 'styled-components';
import { applyThemeToLottie } from 'utils/lottie';
import animationJson from './audio-animation.json';

interface AudioAnimationProps {
  isPaused: boolean;
}

const AudioAnimation = ({ isPaused }: AudioAnimationProps) => {
  const theme = useTheme();
  const animationColors = theme.colors?.mediaPlayer?.audio?.animation;

  const animationData = useMemo(() => {
    if (!animationColors) {
      return animationJson;
    }

    return applyThemeToLottie(animationJson, animationColors);
  }, [animationColors]);

  return (
    <Lottie
      style={{
        position: 'absolute',
      }}
      options={{
        loop: true,
        autoplay: true,
        animationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      }}
      isClickToPauseDisabled={true}
      isPaused={isPaused}
    />
  );
};

export default AudioAnimation;
